import React from 'react';

import styles from '~/components/seed/seed-finder.module.scss';

const FancyHeadings = ({ h1Copy, h2Copy }) => {
  return (
    <div className={styles.fancyHeadings}>
      <h1>{h1Copy}</h1>
      <div className={styles.h2Wrapper}>
        <h2>{h2Copy}</h2>

        {/* Using an inline SVG for clip-path allows us to use `objectBoundingBox` clipPathUnits -> allows the shape to be a bit more responsive */}
        <svg
          width="0"
          height="0"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <clipPath id="clip" clipPathUnits="objectBoundingBox">
              <path
                d="M0.074,1 H0.136 H0.186 H0.237 H0.931 C0.958,1,0.98,0.948,0.982,0.875 L1,0.217 C1,0.137,0.98,0.068,0.951,0.066 L0.053,0.004 C0.022,0.002,-0.002,0.073,0.001,0.156 L0.023,0.876 C0.026,0.948,0.048,1,0.074,1"
                fill="#F7D76F"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  );
};

export default FancyHeadings;
